module.exports = __webpack_public_path__ + "static/gfc-bd78e79b3da0c4049f6c1940e3b962c6.png";